import { render, staticRenderFns } from "./PpWalletConnect.vue?vue&type=template&id=095d4e8a&"
import script from "./PpWalletConnect.vue?vue&type=script&lang=js&"
export * from "./PpWalletConnect.vue?vue&type=script&lang=js&"
import style0 from "./PpWalletConnect.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VRow})
